import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

import { GetBrokerByIdQuery } from 'gql/generated.graphql';

export const isBrokerEqualFormState = (
  broker: GetBrokerByIdQuery['getSingleBrokerById'],
  formStateData: any
) => {
  const brokersPick = [
    'profile.firstName',
    'profile.lastName',
    'account.email',
    'account.phone.number',
    'account.phone.dialCode',
    'account.excludeFromReports',
    'isRealUser',
    'preferredPropertySettings.location.googlePlaceId',
    'preferredPropertySettings.radiusInMiles',
    'agencyName',
    'agencyWebsite',
    'subscriptionType',
    'status',
  ]
    .map((key) => get(broker, key))
    .filter(Boolean);
  const formSatePick = [
    'firstName',
    'lastName',
    'email',
    'phoneNumber.number',
    'phoneNumber.dialCode',
    'isRealUser',
    'excludeFromReports',
    'place.placeId',
    'radius',
    'agencyName',
    'agencyWebsite',
    'subscriptionType',
    'status',
  ]
    .map((key) => get(formStateData, key))
    .filter(Boolean);

  return isEqual(brokersPick, formSatePick);
};
